import { NavLink } from 'react-router-dom';
import styles from './SegmentedControl.module.css';

export type SegmentedControlItem<V extends string = string> = {
  label: string;
  value: V;
  to?: string;
  disabled?: boolean;
};

export type SegmentedControlProps<V extends string = string> = {
  items: SegmentedControlItem<V>[];
  value?: V;
  onChange?: (value: V) => void;
  ariaLabel?: string;
  className?: string;
};

export function SegmentedControl<V extends string = string>({
  items,
  value,
  onChange,
  ariaLabel,
  className,
}: SegmentedControlProps<V>) {
  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className={[styles.root, className].filter(Boolean).join(' ')}
    >
      {items.map((item) =>
        item.to != null ? (
          <NavLink
            key={item.value}
            to={item.to}
            role="tab"
            aria-disabled={item.disabled || undefined}
            className={({ isActive }) =>
              [styles.item, isActive ? styles.active : ''].filter(Boolean).join(' ')
            }
          >
            {item.label}
          </NavLink>
        ) : (
          <button
            key={item.value}
            type="button"
            role="tab"
            aria-selected={value === item.value}
            disabled={item.disabled}
            onClick={() => onChange?.(item.value)}
            className={[styles.item, value === item.value ? styles.active : ''].filter(Boolean).join(' ')}
          >
            {item.label}
          </button>
        )
      )}
    </div>
  );
}
